<template>
  <header class="relative z-10 py-4 px-4 sm:px-6 md:px-10 flex justify-between items-center">
    <div class="flex items-center gap-2 sm:gap-3">
      <router-link to="/" class="flex items-center gap-2 sm:gap-3 no-underline">
      <img src="/ducksImages/duckIcon.webp" class="w-8 h-8 sm:w-10 sm:h-10 drop-shadow-lg" alt="Duck Logo" />
      <h1 class="font-bold text-lg sm:text-xl md:text-2xl text-gray-900">DuckNSeek</h1>
      </router-link>
    </div>
    
    <div class="flex items-center gap-2 sm:gap-3">
      <v-btn
        v-if="!isUserAuthenticated"
        color="#eab308"
        prepend-icon="mdi-login"
        @click="$emit('open-login')"
        class="text-white px-3 sm:px-4"
        :size="isMobile ? 'small' : 'default'"
      >
        Login
      </v-btn>
      
      <!-- Show Admin Dashboard button if authenticated -->
      <v-btn
        v-else
        color="#eab308" 
        prepend-icon="mdi-view-dashboard"
        to="/admin"
        class="text-white px-2 sm:px-4 text-nowrap"
        :size="isMobile ? 'small' : 'default'"
      >
        <span class="hidden sm:inline">Admin Dashboard</span>
        <span class="sm:hidden">Admin Dashboard</span>
      </v-btn>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

defineProps<{
  isUserAuthenticated: boolean;
}>();

defineEmits<{
  (e: 'open-login'): void;
}>();

const isMobile = ref(false);

// Check if screen is mobile size
const checkMobile = () => {
  isMobile.value = window.innerWidth < 640;
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>

<style scoped>
/* Ensure better tap target sizes on mobile */
@media (max-width: 640px) {
  :deep(.v-btn__content) {
    font-size: 0.875rem;
  }
}
</style>
